import {BaseCachedService} from './Core/BaseCachedService';
import {BaseService} from "./Core/BaseService";
import {ObjectUtils, FileUtils} from "../Utils";

class ReportService extends BaseCachedService {
    get Url() { return super.Url + "/reports"; }

    Get(programId = null, projectId = null, sampleEventPhaseId = null) {
        let request = {programId, projectId, sampleEventPhaseId};
        return this.SendRequest(BaseService.GET, request);
    }

    DownloadPhotos(projectId = null, sampleEventId = null) {
        return this.DownloadFile({projectId, sampleEventIds: sampleEventId.join(',')}, '/photos');
    }

    Print(projectId, sampleEventPhaseCode, procedureCodes) {
        return this.DownloadFile({projectId, sampleEventPhaseCode, procedureCodes});
    }
    
    DownloadFile(data, suffix = '') {
        const anchor = document.createElement("a");

        this.SetLoading();

        const headers = new Headers();
        headers.append('Authorization', BaseService.AUTH_TOKEN);

        let filename;
        const body = ObjectUtils.BuildFormData(data);

        return fetch(`${this.Url}${suffix}`, {
            method: 'POST',
            body,
            headers,
        })
        .then(response => {
            if (!response.ok) {
                alert('Unfortunately we have failed to download the file.')
            }
            return response;
        })
        .then(response => {
            const contentDispositionHeader = response.headers.get('Content-Disposition');
            filename = FileUtils.GetFileNameFromContentDisposition(response.headers.get('Content-Disposition'));
            return response.blob(); 
        })
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);
            anchor.href = objectUrl;
            anchor.download = filename;
            anchor.click();
            this.SetLoading(false);
            URL.revokeObjectURL(objectUrl);
        })
        .catch(response => {
            throw Error(response.message ?? response.statusText ?? 'This file is not available because an unexpected error occurred.');
        });
    }
}

export const service = new ReportService();

